/**
 * ProcurementSettingService
 * Service for ProcurementSetting entity operations
 * Route: api/procurementsetting
 */
import { CrudService } from '../base/CrudService';
export class ProcurementSettingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProcurementSettingService.DEFAULT_SERVICE_PATH,
            basePath: ProcurementSettingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get a setting by its unique key.
     * GET /api/procurementsetting/by-key/{key}
     */
    async getByKey(key) {
        const url = this.buildUrl(`by-key/${encodeURIComponent(key)}`);
        const response = await this.http.get(url);
        if (!response.data)
            throw new Error(`Setting '${key}' not found`);
        return response.data;
    }
    /**
     * Refresh the settings cache from the database.
     * POST /api/procurementsetting/cache/refresh
     */
    async refreshCache() {
        const url = this.buildUrl('cache/refresh');
        const response = await this.http.post(url);
        return response.data ?? [];
    }
}
ProcurementSettingService.DEFAULT_SERVICE_PATH = 'procurements';
ProcurementSettingService.BASE_PATH = 'api/procurementsetting';
//# sourceMappingURL=ProcurementSettingService.js.map